<template>
  <div>
    <span v-if="row.order">{{ row.order.total }}</span>
    <span v-else-if="row.ccr_order">{{ row.ccr_order.total_amount }}</span>
  </div>
</template>

<script>
export default {
  name: 'OrderAmount',
  components: { },
  props: {
    row: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/coupon_codes/common/OrderAmount.vue